T<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap >
      <v-flex sm12>
        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modaluser.dialog" persistent max-width="500px">
            <v-btn color="primary" dark slot="activator">Novo Usuário</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Cadastro de Usuários</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                      label="Nome"
                      v-model="usuario.name"
                      :rules="[rules.required]"
                      required></v-text-field>
                    </v-flex>                     
                    <v-flex xs12>
                      <v-text-field
                      label="E-mail"
                      v-model="usuario.email"
                      :rules="[rules.required, rules.email]"
                      required></v-text-field>
                    </v-flex>            
                    <v-flex xs12>
                      <v-text-field
                      type="password"
                      label="Senha"
                      v-model="usuario.password"
                      :rules="[rules.required]"
                      required></v-text-field>
                    </v-flex>                         
                    <v-flex xs12>
                      <v-text-field
                      type="password"
                      label="Confirme a Senha"
                      v-model="usuario.password_confirmation"
                      :rules="[rules.required]"
                      required></v-text-field>
                    </v-flex>          
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="modaluser.dialog = false">Fechar</v-btn>
                <v-btn color="blue darken-1" flat @click="creatUser()">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-flex>

      <!-- tabela de treinamentos -->  
      <v-flex lg12>
        <vue-good-table
        :columns="columns"
        :rows="users"
        @on-row-click="clickTd"
        :pagination-options="{
        enabled: true,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Registros por página',
        ofLabel: 'of',
        allLabel: 'Todos',
      }"
      styleClass="vgt-table bordered vgt-table condensed">
    </vue-good-table>
  </v-flex>

  <v-flex lg12>
    <v-card >
      <v-alert outline color="info" icon="info" :value="true">
        Clique sobre os usuários para verificar os dados
      </v-alert>
    </v-card> 
  </v-flex> 

  <v-flex>
    <v-dialog v-model="modaledituser.dialog" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Editando Usuários</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                label="Nome"
                v-model="dados_user.name"
                :rules="[rules.required]"
                required></v-text-field>
              </v-flex>                     
              <v-flex xs12>
                <v-text-field
                label="E-mail"
                v-model="dados_user.email"
                :rules="[rules.required, rules.email]"
                required></v-text-field>
              </v-flex>                       
              <v-flex xs6>
                <v-switch
                label="Ativo"
                v-model="dados_user.active"
                ></v-switch>  
              </v-flex>                
              <v-flex xs6>
                <v-switch
                label="Perfil (Desmarco-Usuário da empresa, Marcado-Usuário cliente)"
                v-model="dados_user.role"
                ></v-switch>  
              </v-flex>           
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="modaledituser.dialog = false">Fechar</v-btn>
          <v-btn color="blue darken-1" flat @click="updateUser()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>  


</v-layout>
</v-container>    

</template>

<script>
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      users: [],
      dados_user: [],
      columns: [
      {
        label: 'Nome',
        field: 'name',
        filterOptions: {
            enabled: true, 
            placeholder: 'Informe o nome do usuário',
            filterDropdownItems: [],  
            filterFn: this.columnFilterFn, 
          },
        },
        {
          label: 'E-mail',
          field: 'email',
          filterOptions: {
              enabled: true,
              placeholder: 'Informe o e-mail', 
              filterDropdownItems: [],
              filterFn: this.columnFilterFn,
            },
          }
          ],

          usuario: {
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
          },

          modaluser: {
            dialog: false
          },          
          modaledituser: {
            dialog: false
          },            
          rules: {
            required: (value) => !!value || 'Campo Obrigtório.',
            email: (value) => {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || 'E-mail inválido.';
            } 
          },
        };
      },

      mounted () {
        this.buscaUser();
      }, 

      methods: {

        buscaUser() {

          http.get('users')
          .then(response => {
                var users = [];
                 for (var i = 0; i < response.data.length; i++) {
                  
                  if(response.data[i].role === 1) {
                    users.push(response.data[i])
                 }
               }
                this.users = users;
             })    
          .catch(error => {
            console.log()
          });
        },


        creatUser() {

          if(this.usuario.password != this.usuario.password_confirmation){
            swal({
              title: "Verifique a senha,",
              text: "pois elas não conferem!",
              icon: "error",
              timer: 2000,
              button: false

            });
          }          

          if(this.usuario.password != this.usuario.password_confirmation){
            swal({
              title: "Verifique a senha,",
              text: "pois elas não conferem!",
              icon: "error",
              timer: 2000,
              button: false

            });
          }

          http.post('users',{
            email: this.usuario.email,
            name: this.usuario.name,
            password: this.usuario.password,
            password_confirmation: this.usuario.password_confirmation,
            role: 1   
          })
          .then(response => {

            this.modaluser.dialog = false
            this.buscaUser()
            swal({
              title: "Usuário!",
              text: "cadastrado com sucesso!",
              icon: "success",
              timer: 1000,
              button: false

            });
          })
          .catch(error => {
            console.log();
          });
        },

        clickTd(params)
        {
          if(params.row.id == null || params.row.id == '')
          {
            swal({
              title: "Não",
              text: "foi possível editar o cadastro!",
              icon: "success",
              timer: 1000,
              button: false

            });
          }  
          this.modaledituser.dialog = true;

          let id_user = params.row.id;
          let token = this.$localStorage.get('token')

          let data = {
            id: params.row.id,
            email: params.row.email,
            name: params.row.name,
            password: params.row.password,
            password_confirmation: params.row.password_confirmation,
            active: params.row.active,
            role: params.row.role,
            
          }
          this.dados_user = data;
        },

        updateUser()
        {
          http.put('users/' + this.dados_user.id, {
            name: this.dados_user.name,
            email: this.dados_user.email,
            role: this.dados_user.role,
            active: this.dados_user.active,
          })
          .then(response => {

            this.buscaUser();

            swal({
              title: "Usuário!",
              text: "atualizado com sucesso!",
              icon: "success",
              timer: 1000,
              button: false

            });

            this.modaledituser.dialog = false;
            this.dados_user.push(response.data);
          })
          .catch(error => {
            this.errors = [];
          });
        }, 

      }
    };
    </script>
    <style scoped lang="css">
    .custom-class{
      background-color: #b3d4fc!important
    }
    </style>



// WEBPACK FOOTER //
// src/components/usuarios/Usuarios.vue